/* 馬超傳・第 2 章：潼關（上）渭口截渡（建安十六年，211）
 * 史實：《武帝紀》「公自潼關北渡，未濟，超赴船急戰。校尉丁斐因放牛馬以餌賊，賊亂取牛馬，公乃得渡。」
 *       《許褚傳》「超將步騎萬餘人，來奔太祖軍，矢下如雨。……褚斬攀船者，左手舉馬鞍蔽太祖。」
 * 和曹操傳第 11 章「潼關・許褚護渡」是同一場仗的兩邊（同一張地圖 tongguan）。
 * 這是第 2 章的第二幕（def.of，第一幕是蒲阪夜襲 machao2a）。
 * 流程：曹軍大部隊已經過河，曹操和許褚、虎士留在南岸。馬超帶兵衝向碼頭；丁斐放出牛馬，一半的兵跑去搶，要邊打邊叫回來。
 *       曹操上船後，馬超的兵在岸上放箭（矢下如雨）；許褚把馬鞍舉向上一輪箭射來的方向——一直站在同一處射都會被擋下，要沿岸換位置。
 *       船到北岸，曹操照史實逃脫。評星看射中幾箭。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, hero, TROOPS } from '../kit.ts';
import { band, turn, drawCone } from './machao_kit.ts';
import { DOCK, LANDING } from '../maps/tongguan.ts';

const LV = 12, BOARD = 28, SHIELD = (22 * Math.PI) / 180, TURN = 0.9, VOLLEY = 1.8, RANGE = 1300;
const HUSHI = { spec: TROOPS.wei, name: '虎士', hp: 620, maxHp: 620, atk: 30 };
const CATTLE = [5200, 3500];
const cow = (ctx, f, T) => SG.drawHorse(ctx, f.x, f.y, f.f, f.walk ? T : 0, f.col, '#4a3020', 0.8);

export default {
  id: 'machao-2', of: 'machao-2a', map: 'tongguan', hero: 'machao',
  title: '第 2 章　潼關（上）：截渡', year: '建安十六年（211）',
  brief: {
    quote: [{ text: '公自潼關北渡，未濟，超赴船急戰。', src: '《三國志·魏書·武帝紀》' }],
    text: '曹操從潼關北渡黃河，大軍先過，自己和許褚、虎士百餘人留在南岸斷後。馬超帶步騎萬餘人殺到碼頭。',
    goals: ['衝向碼頭', '把跑去搶牛馬的兵叫回來', '沿岸放箭：換到許褚馬鞍擋不到的一側'],
  },
  words: { ally: '西涼騎', foe: '虎士' },
  stars: [ // 兩幕合算
    { text: '夜襲：天亮前殺傷曹兵 10 人以上', ok: (m) => !m.prev || (m.prev.vars.slainNight || 0) >= 10 },
    { text: '搶牛馬的兵全部叫回來', ok: (m) => m.vars.lured && m.vars.lured.every((u) => !u.alive || u.owner) },
    { text: '射中曹操 3 箭以上', ok: (m) => (m.vars.hits || 0) >= 3 },
  ],
  steps: [
    { // 0. 衝向碼頭；丁斐放牛馬
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = 6600; me.y = 3700;
        V.t0 = w.t; V.hits = 0; V.blocked = 0;
        V.men = band(m, me, 10, '西涼騎', { hp: 560, atk: 26 });
        V.cao = boss(w, hero('caocao'), DOCK[0] - 60, DOCK[1] + 60, { name: '曹操', hp: 6000, atk: 0, untargetable: true, ms: 200 });
        V.xc = boss(w, hero('xuchu'), DOCK[0] + 120, DOCK[1] + 140, { name: '許褚', hp: 7000, atk: 70, armor: 10, ms: 230 });
        V.hs = Array.from({ length: 10 }, (_, i) => { const u = m.foe('huangjin', DOCK[0] + 250 + (i % 5) * 80, DOCK[1] + 280 + Math.floor(i / 5) * 120, HUSHI); u.home = [u.x, u.y]; return u; });
        V.shield = Math.PI / 2 - 0.5; // 許褚的馬鞍朝向（地面度量的角度；先朝南岸）
        m.line('馬超', '曹賊就在碼頭！趁他還沒上船，殺過去！');
        m.mark('dock', DOCK[0], DOCK[1] + 100, '碼頭');
        m.obj('dock', '');
        // 丁斐放牛馬：一半的兵跑去搶
        m.after(9, () => {
          m.card('校尉丁斐因放牛馬以餌賊，賊亂取牛馬。', '《武帝紀》');
          V.cattle = Array.from({ length: 8 }, (_, i) => m.folk(CATTLE[0] - 300 + (i % 4) * 160, CATTLE[1] - 150 + Math.floor(i / 4) * 220, { name: i % 2 ? '牛' : '馬', draw: cow, col: i % 2 ? '#7a5a3a' : '#a08a6a', near: 1 }));
          V.lured = m.alive(V.men).filter((_, i) => i % 2 === 0);
          for (const u of V.lured) { u.owner = null; u.home = [CATTLE[0] + (SG.rand() - 0.5) * 500, CATTLE[1] + (SG.rand() - 0.5) * 300]; u.loot = true; }
          m.line('西涼騎', '牛！馬！搶啊！');
          m.after(2, () => m.line('提示', '跑去搶牛馬的兵不會跟著走：走到他們身邊就能叫回來。'));
          m.obj('call', '把搶牛馬的兵叫回來', V.lured.length);
        });
      },
      tick(m, w) {
        const V = m.vars, left = BOARD - (w.t - V.t0);
        m.get('dock').text = `衝向碼頭（${Math.max(0, Math.ceil(left))} 秒後曹操上船）`;
        return left <= 0;
      },
    },
    { // 1. 曹操上船：矢下如雨
      enter(m, w) {
        const V = m.vars;
        m.done('dock'); m.unmark('dock');
        V.xc.untargetable = true; V.xc.target = null;
        V.b = m.boat(V.cao, { x: DOCK[0], y: DOCK[1] - 60, sp: 42, crew: [V.xc], flag: '#3b5a99', big: true });
        V.b.goal = [LANDING[0], LANDING[1] + 60];
        V.volT = 1;
        m.card('褚白太祖，賊來多，今兵渡已盡，宜去，乃扶太祖上船。', '《許褚傳》');
        m.after(2, () => m.line('提示', '站在南岸、和船左右相距不遠，部下就會放箭。許褚會把馬鞍舉向上一輪箭射來的方向：站著不動一直射都會被擋下，沿著河岸換個位置再射。'));
        m.mark('boat', V.b.x, V.b.y, '曹操', false, V.cao);
        m.obj('shoot', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, b = V.b;
        // 許褚把馬鞍轉向上一輪箭射來的方向（畫面上的角度）
        const ang = (u) => Math.atan2(u.y - V.cao.y, u.x - V.cao.x);
        V.shield = turn(V.shield, V.aim != null ? V.aim : ang(me), TURN, dt);
        m.get('shoot').text = `放箭：射中曹操 ${V.hits} 箭（被馬鞍擋下 ${V.blocked}）`;
        V.volT -= dt;
        if (V.volT <= 0 && me.alive && me.y > 2700 && Math.abs(me.x - V.cao.x) < RANGE) {
          V.volT = VOLLEY;
          const a = ang(me); V.aim = a;
          let da = a - V.shield; while (da > Math.PI) da -= Math.PI * 2; while (da < -Math.PI) da += Math.PI * 2;
          w.fx({ k: 'spark', x: V.cao.x, y: V.cao.y - 60, col: '#ffd8a0' });
          if (Math.abs(da) < SHIELD) { V.blocked++; w.dmgEvents.push({ x: V.cao.x, y: V.cao.y - 80, text: '舉鞍', team: 1, src: me.id, tgt: V.cao.id }); }
          else { V.hits++; w.dmgEvents.push({ x: V.cao.x, y: V.cao.y - 80, text: '中箭！', team: 0, src: me.id, tgt: V.cao.id }); if (V.hits === 1) m.line('馬超', '射中了！再射！'); }
        }
        return b.y < LANDING[1] + 200 || !b.goal;
      },
    },
    { // 2. 公乃得渡
      enter(m, w) {
        const V = m.vars;
        m.done('shoot'); m.unmark('boat');
        m.card('褚斬攀船者，左手舉馬鞍蔽太祖。船工為流矢所中死，褚右手並溯船，僅乃得渡。', '《許褚傳》');
        m.after(3, () => m.card('賊亂取牛馬，公乃得渡。', '《武帝紀》'));
        m.after(5, () => m.line('馬超', '……讓他過去了。'));
        m.after(8, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('馬超陣亡'); return; }
    // 叫回搶牛馬的兵
    if (V.lured) {
      for (const u of V.lured) if (u.alive && !u.owner && SG.gd(u.x, u.y, me.x, me.y) < 220) { m.join(u, me); u.loot = false; w.dmgEvents.push({ x: u.x, y: u.y - 50, text: '歸隊', team: 0, src: u.id }); }
      const n = V.lured.filter((u) => !u.alive || u.owner).length;
      if (m.get('call')) { m.prog('call', n); }
    }
    // 許褚：馬超靠近就衝著他來（上船之前）
    if (m.i === 0 && V.xc.alive && SG.gd(V.xc.x, V.xc.y, me.x, me.y) < 420 && V.xc.target !== me) { V.xc.target = me; V.xc.think = 0.5; }
    if (m.i === 0 && V.xc.alive && SG.gd(V.xc.x, V.xc.y, DOCK[0], DOCK[1]) > 600) { V.xc.target = null; V.xc.home = [DOCK[0] + 120, DOCK[1] + 140]; } // 不離開碼頭
  },
  // 許褚的馬鞍：船上朝馬鞍方向畫一片扇形
  ground(ctx, m) {
    const V = m.vars;
    if (m.i !== 1 || !V.cao) return;
    drawCone(ctx, { x: V.cao.x, y: V.cao.y, a: Math.atan2(Math.sin(V.shield) / SG.K, Math.cos(V.shield)), half: SHIELD, r: 260 }, '#c8a060', 0.22);
  },
};
